export default __webpack_public_path__ + "static/media/dashboardSettings.74931378.svg";